export const locale = {
    lang: 'pt-br',
    data: {
        'SAMPLE': {
            'HELLO': 'Olá, mundo!'
        }
    }
};
